<template lang="pug">
div.neutral200
  v-container.pa-8(style="max-width:900px")
    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

    template(v-else)
      v-row(no-gutters align="center")
        v-col.shrink
          v-btn.ml-n3(text icon @click="goBack" height)
            v-icon(color="basic800" :size="24") mdi-arrow-left
        v-col.ml-3
          div.text-2xl.font-semibold.neutral700--text Edit user

      v-form(ref="form")
        v-card.pa-6.mt-4.round-xl(outlined)
          .text-md.font-semibold.neutral700--text User detail
          v-row.mt-2(v-if="roles.length" no-gutters)
            v-col(cols="6")
              template(v-if="roles.includes('Agent')")
                div.text-sm.font-medium.neutral500--text {{ $t('profile_image') }}
                div.d-flex.align-center.mt-2  
                  v-avatar(size="64" color="neutral300")
                    div(v-if="resizeImageFileUrl" align="center")
                      v-img(:src="resizeImageFileUrl" contain max-height="64" max-width="64")
                        template(v-slot:placeholder)
                          v-row(class="fill-height ma-0" align="center" justify="center")
                            v-progress-circular(indeterminate color="grey")
                    v-icon(v-else color="neutral500" size="30") $yzi-user-03

                  div.file-change-layout.ml-4
                    v-btn.button-sm(color="basic700" outlined depressed) {{ $t('update') }}
                    input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 92px !important")

              div.text-sm.font-medium.neutral500--text.mt-4 First name
              v-text-field.text-sm.font-normal.mt-2.round-xl(v-model="firstName" placeholder="First name" outlined readonly dense height="48" hide-details="auto" maxlength="30")
              div.text-sm.font-medium.neutral500--text.mt-4 Last name
              v-text-field.text-sm.font-normal.mt-2.round-xl(v-model="lastName" placeholder="Last name" outlined readonly dense height="48" hide-details="auto")

              template(v-if="roles.includes('Agent')")
                div.text-sm.font-medium.neutral500--text.mt-4 {{ $t('type_of_provider') }}
                provider-type-dropdown.mt-2(v-model="type" field-class="text-sm" :error="errorProviderType" @change="removeError")
                div.text-sm.font-medium.neutral500--text.mt-4 MMC Registration No.
                v-text-field.text-sm.font-normal.mt-2.round-xl(v-model="mmcNumber" placeholder="MMC Registration No" outlined dense height="48" hide-details="auto")

        v-card.pa-6.mt-4.round-xl(outlined)
          .text-md.font-semibold.neutral700--text Role and account
          v-row.mt-4(align="center")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text {{ $t('email') }}
            v-col(:class="{ 'py-2': !email }")
              div.text-sm.neutral700--text(v-if="email") {{ email }}
              y-button(v-else label="Setup user" size="sm" outlined @click="openSetupUser = true")
          v-row(align="center")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Username
            v-col(cols="4" :class="{ 'py-2': showUsernameField }")
              v-text-field.text-sm.font-normal.round-xl(v-if="showUsernameField" v-model="username" placeholder="Username" outlined dense height="48" hide-details="auto" autofocus :loading="isFetchingUsername" :error-messages="userErrorMessage" @input="inputChanged" @blur="checkUsername('blur')")
                template(#append)
                  v-icon.mt-1(v-if="availableUsername === false" color="danger500") mdi-alert-circle-outline
                  v-icon.mt-1(v-if="availableUsername === true" color="success500") mdi-check-circle-outline
              div.d-flex.align-center(v-else)
                template(v-if="username")
                  div.text-sm.neutral700--text {{ username }}
                  v-btn.ml-3(@click="showUsernameField = !showUsernameField" color="primary400" icon)
                    v-icon(small color="neutral700") $yzi-edit-02
                div(v-else style="padding-top: 2px; padding-bottom: 2px;")
                  y-button(label="Set username" size="sm" outlined @click="showUsernameField = true")
          v-row(v-if="email" align="center")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Password
            v-col.py-2
              y-button(label="Reset password" size="sm" outlined @click="openResetPassword = true")
          v-row(align="center")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Sign in link
            v-col
              div.d-flex.align-center
                div.text-sm.neutral700--text {{ getSignInLink() }}
                v-btn.ml-3(icon small @click="copyLink" v-clipboard:copy="getSignInLink()")
                  v-icon(small color="neutral700") $yzi-copy-03
          v-card.round-xl.mt-4(outlined)
            v-row(no-gutters)
              v-col.pa-4(cols="5")
                div.text-sm.font-semibold.neutral200.neutral700--text.py-2.px-3 Admin roles
                y-checkbox.my-2(v-model="roles" value="Admin" :disabled="disableAdminRoles")
                  template(#label)
                    .text-md.neutral700--text Admin
                template(v-if="company.primary_owner != id")
                  div.text-sm.font-semibold.neutral200.neutral700--text.py-2.px-3 Health providers
                  y-checkbox.my-2(v-model="roles" value="Agent")
                    template(#label)
                      .text-md.neutral700--text Doctor & clinical staff
                div.text-sm.font-semibold.neutral200.neutral700--text.py-2.px-3 Support roles
                y-checkbox.my-2(v-model="roles" value="Salesperson")
                  template(#label)
                    .text-md.neutral700--text Clinic assistant
                //- div.text-sm.font-semibold.neutral200.neutral700--text.py-2.px-3 Finance roles
                //- y-checkbox.my-2(v-model="roles" value="Bookkeeper")
                //-   template(#label)
                //-     .text-md.neutral700--text Billings & claims
              v-divider(vertical)
              v-col.pa-4(cols="7")
                div.text-md.font-semibold.neutral700--text Role Description
                div.text-xs.neutral500--text Users will receive the combined set of permissions allowed according to their roles.
                v-divider.mt-3
                div.mt-3(v-if="roles.includes('Admin')")
                  div.text-sm.font-semibold.neutral700--text Admin
                  div.text-sm.neutral700--text This role is for people who need similar access as the account owner. This role can see and manage almost everything.
                div.mt-3(v-if="roles.includes('Agent')")
                  div.text-sm.font-semibold.neutral700--text Doctor & clinical staff
                  div.text-sm.neutral700--text Clinical Staff and Doctors can view and update patient health records and prescriptions, as well as book appointments.
                div.mt-3(v-if="roles.includes('Salesperson')")
                  div.text-sm.font-semibold.neutral700--text Clinic assistant
                  div.text-sm.neutral700--text This role can see general patient information and appointment schedules, with the ability to adjust appointments. They cannot access detailed medical data or change system settings.
                div.mt-3(v-if="roles.includes('Bookkeeper')")
                  div.text-sm.font-semibold.neutral700--text Billings & claims
                  div.text-sm.neutral700--text This role should be able to access financial data such as invoices, payments, and insurance details. They have the ability to make changes to this data, but should not have access to medical records or other sensitive information.
                div.mt-4(v-if="roles.length && !roles.includes('Admin')")
                  y-checkbox.my-2(v-model="hideClinicManagement")
                    template(#label)
                      .text-sm.neutral700--text Do not allow viewing clinic management
                  y-checkbox.my-2(v-model="hideSalesReport")
                    template(#label)
                      .text-sm.neutral700--text Do not allow viewing sales report
                  y-checkbox.my-2(v-model="allowAddUser")
                    template(#label)
                      .text-sm.neutral700--text Allow manage users
                  y-checkbox.my-2(v-model="allowCancelVisit")
                    template(#label)
                      .text-sm.neutral700--text Allow cancel visit (Registration)

        //- v-card.pa-6.mt-4.round-xl(v-if="notification && notification.settings" outlined)
          .text-md.font-semibold.neutral700--text Email notification settings
          .text-sm.neutral700--text Configure your email notification settings
          div.d-flex.align-center.mt-4
            div.ml-n2.mr-3
              y-switch.mb-n2(v-model="notification.settings.email.appointment_booked")
            div.text-sm.font-medium New appointment booked


        template(v-if="roles.includes('Agent')") 
          v-card.px-6.pb-8.mt-4.round-xl(outlined)
            provider-availability          
          v-card.px-6.pb-8.mt-4.round-xl(outlined)
            provider-service

    v-footer.white(app inset padless elevation="3")
      v-container.px-8.py-2
        div.d-flex.align-center
          v-spacer
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" button-class="px-0" @click="goBack")
          y-button(:label="$t('save')" text-color="neutral100" color="neutral700" :dark="!Boolean(roles.length === 0)" :disabled="Boolean(roles.length === 0)" :loading="isLoading" @click="saveData")

  .dialogs
    setup-user-dialog(v-if="openSetupUser" :open.sync="openSetupUser" :provider="provider" @closed="closed" @reset="reset")
    reset-password-dialog(v-if="openResetPassword" :open.sync="openResetPassword" :email="email" @closed="closed" @reset="reset")

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { resizeImage, debounce } from '@/utils'
import ProviderAvailability from '@/components/clinic/manage/ProviderAvailability.vue'
import ProviderService from '@/components/clinic/manage/ProviderService.vue'
import ProviderTypeDropdown from '@/components/clinic/appointment/custom/ProviderTypeDropdown.vue'
import SetupUserDialog from '@/components/clinic/usersettings/SetupUserDialog.vue'
import ResetPasswordDialog from '@/components/clinic/usersettings/ResetPasswordDialog.vue'

export default {
  name: 'EditUser',
  props: ['id'],
  components: { ProviderAvailability, ProviderService, ProviderTypeDropdown, SetupUserDialog, ResetPasswordDialog },
  data () {
    return {
      isLoading: false,
      isFetching: false,
      isFetchingUsername: false,
      openSetupUser: false,
      openResetPassword: false,
      errorProviderType: false,
      showUsernameField: false,
      hideClinicManagement: false,
      hideSalesReport: false,
      allowCancelVisit: true,
      allowAddUser: false,
      passwordType: 'text',
      type: 'Doctor',
      resizeImageFileUrl: '',
      resizeImageFile: null,
      role: null,
      firstName: null,
      lastName: null,
      username: null,
      oriUsername: null,
      availableUsername: null,
      userErrorMessage: null,
      email: null,
      password: null,
      confirmPassword: null,
      mmcNumber: null,
      provider: null,
      user: null,
      roles: [],
      notification: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
        password: [(v) => (v != null && v.toString().trim().length) || 'This field is required', (v) => (v != null && v.length >= 8) || 'Password must be at least 8 characters long'],
        confirm_password: [v => !!v || 'This field is required', v => v === this.password || 'Passwords do not match'],
        email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany',
      form: 'clinic/getForm',
      tempProvider: 'clinic/getTempProvider'
    }),
    isAdmin () {
      return this.member.roles.includes('Admin')
    },
    disableAdminRoles () {
      if (this.company.primary_owner == this.id) {
        return true
      }
      if (!this.isAdmin) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.fetchUser()
    // this.fetchNotification()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchUser () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/members/${this.id}`)
        .then(resp => {
          this.firstName = resp.data.user.first_name
          this.lastName = resp.data.user.last_name
          this.username = resp.data.username
          this.oriUsername = resp.data.username
          this.email = resp.data.user.email
          this.roles = resp.data.roles
          this.user = resp.data.user
          this.provider = resp.data.provider || null
          this.hideClinicManagement = resp.data.no_clinic_management
          this.hideSalesReport = resp.data.no_sales_report
          this.allowCancelVisit = resp.data.can_cancel_visit
          this.allowAddUser = resp.data.can_add_user
          if (resp.data.roles.includes('Agent')) {
            if (resp.data.profile_image) {
              this.resizeImageFileUrl = resp.data.profile_image.file
            }
            this.type = resp.data.type
            this.mmcNumber = resp.data.mmc_no
            let setProvider = { id: resp.data.provider, services: resp.data.services, schedules: resp.data.schedules }
            this.$store.commit('clinic/setProvider', setProvider)
          }
          this.isFetching = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchNotification () {
      this.$axios.get(`/notifications/settings/?member=${this.id}`)
        .then(resp => {
          this.notification = resp.data
        })
        .catch(() => {})
    },
    checkUsername (blur) {
      if (!this.username || (this.username === this.oriUsername)) {
        this.availableUsername = null
        this.userErrorMessage = null
        if (blur) {
          this.showUsernameField = false
        }
        return
      }
      const alphanumericLowecaseMax25 = /^[a-z0-9]{1,25}$/
      if (!alphanumericLowecaseMax25.test(this.username)) {
        this.userErrorMessage = 'Alphanumeric lowercase only, max 25 characters'
        return
      }
      this.isFetchingUsername = true
      const params = {
        company: this.company.id,
        username: this.username
      }
      this.$axios.get('/members/check_username', { params })
        .then(resp => {
          this.availableUsername = resp.data.available
          if (this.availableUsername === false) {
            this.userErrorMessage = 'This username is already taken'
          } else {
            this.userErrorMessage = null
          }
        })
        .finally(() => {
          this.isFetchingUsername = false
          if (this.availableUsername && blur) {
            this.showUsernameField = false
          }
        })
    },
    inputChanged: debounce(function () {
      this.checkUsername()
    }, 750),
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    saveData () {
      if (this.roles.includes('Agent') && !this.type) {
        this.errorProviderType = true
      }
      if (!this.$refs.form.validate() || (this.roles.includes('Agent') && !this.type)) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all')])
        return
      }
      if (this.availableUsername === false) {
        this.showMessage(['error', "This username is already taken. Please choose a different username."])
        return
      }
      this.isLoading = true
      let data = {
        roles: this.roles,
        role: this.getRoleCode(this.roles[0]),
        username: this.username || null,
        no_clinic_management: this.roles.includes('Admin') ? false : this.hideClinicManagement,
        no_sales_report: this.roles.includes('Admin') ? false : this.hideSalesReport,
        can_cancel_visit: this.roles.includes('Admin') ? true : this.allowCancelVisit,
        can_add_user: this.roles.includes('Admin') ? true : this.allowAddUser
      }
      if (this.roles.includes('Agent')) {
        data.type = this.type
        data.mmc_no = this.mmcNumber
        data.services = this.tempProvider.services
        data.schedules = this.tempProvider.schedules
        if (!this.provider) {
          data.date_overrides = this.tempProvider.date_overrides
        }
      }
      this.$axios.patch(`/clinics/${this.company.slug}/members/${this.id}`, data)
        .then(resp => {
          if (this.resizeImageFile) {
            this.updateProviderImage(resp.data)
          } else {
            this.isLoading = false
            this.$router.push('/admin/clinic/users')
          }
          // this.updateNotificationSettings()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isLoading = false
        })
    },
    updateProviderImage (data) {
      var params = new FormData()
      params.append('profile_image', this.resizeImageFile)
      this.$axios.patch(`/clinics/${this.company.slug}/members/${data.id}`, params)
        .then(() => {
          this.isLoading = false
          this.$router.push('/admin/clinic/users')
        })
        .catch(() => {})
    },
    updateNotificationSettings() {
      if (this.notification && this.notification.settings) {
        this.$axios.post(`/notifications/settings`, this.notification)
          .catch(() => {})
      }
    },
    getRole (role) {
      if (role === 'Salesperson') { return 'Clinic assistant'}
      if (role === 'Agent') { return 'Doctor'}
      else { return role }
    },
    getRoleCode (role) {
      switch (role) {
        case 'Admin':
          return 1
        case 'Salesperson':
          return 2
        case 'Agent':
          return 3
        default:
          return 1
      }
    },
    getSignInLink () {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return `http://${window.location.host}/signin/clinic?slug=${this.company.slug}`
      } else {
        return `https://${process.env.VUE_APP_BASE_DOMAIN}/signin/clinic?slug=${this.company.slug}`
      }
    },
    copyLink() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
    },
    goBack () {
      this.$router.go(-1)
    },
    removeError () {
      if (this.type) {
        this.errorProviderType = false
      }
    },
    reset () {
      this.fetchUser()
      this.closed()
    },
    closed () {
      this.openSetupUser = false
      this.openResetPassword = false
    },
  },
  destroyed () {
    this.$store.commit('clinic/resetProvider')
    this.$store.commit('clinic/resetTempProvider')
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>